<script setup>
import {ref, watch} from 'vue';
import Textarea from 'primevue/textarea';
import Button from 'primevue/button';

import { storeToRefs } from 'pinia';
import { useCadernoStore } from './useCardernoStore';
const store = useCadernoStore();
const { atualizandoComentario } = storeToRefs(store);

const model = defineModel();
const props = defineProps({idAnotacao: Number, comentarioSalvo: Boolean});
const atualizando = ref(false);

async function atualizarComentario() {
   atualizando.value = true;
   await store.atualizarComentario(props.idAnotacao, model.value);
   atualizando.value = false;
}

watch(model, () => {
    store.atualizarStatusDoComentario(props.idAnotacao, false);
}, {deep: true});


</script>
<template>
   <div class="flex gap-2">
    <Textarea v-model="model" autoResize rows="1" cols="30" placeholder="Comentario do professor" class="w-full"/>
    <Button :disabled="comentarioSalvo" :loading="atualizando" icon="pi pi-save" text v-tooltip.top="'Salvar comentario'" @click="atualizarComentario" />
   </div>
</template>